import "./Game.css";
import { useEffect, useState } from "react";
import useSound from "use-sound";

import successfullySound from "../../assets/audio/successfully.mp3";
import errorSound from "../../assets/audio/error.mp3";
import { useWindowActive } from "../../hooks/useWindowActive";
import { DELAY_NEXT_QUESTION_SECONDS, NUMBER_QUESTIONS_END, ADD_SCORE } from "../../utils/config";

export function Game({ lang, isSound, dataLocalStorage, setDataLocalStorage }) {
	const [dataGame, setDataGame] = useState(null);
	const [dataMenu, setDataMenu] = useState(null);
	const [isAnswerSelected, setIsAnswerSelected] = useState(false);
	// const [isMenu, setIsMenu] = useState(false);
	const [isFinal, setIsFinal] = useState(false);
	const [isFeedback, setIsFeedback] = useState(true);

	useEffect(() => {
		if (typeof YaGames === "undefined" || typeof YaGames.init !== "function") {
			console.error("ysdk.feedback.canReview");
			return;
		}

		ysdk.feedback.canReview().then(({ value }) => {
			setIsFeedback(value);
		});
	}, []);

	const [playSuccessfullySoundMusic, { stop: stopSuccessfullySoundMusic }] = useSound(successfullySound, {
		volume: 0.02,
	});
	const [playErrorSoundMusic, { stop: stopErrorSoundMusic }] = useSound(errorSound, { volume: 0.02 });

	const isWindowActive = useWindowActive();

	useEffect(() => {
		if (typeof YaGames === "undefined" || typeof YaGames.init !== "function") {
			console.error("ysdk.features.GameplayAPI");
			return;
		}
		if (isWindowActive) {
			ysdk.features.GameplayAPI?.start();
			console.log("ysdk.features.GameplayAPI.start");
		} else {
			console.log("ysdk.features.GameplayAPI.stop");
			ysdk.features.GameplayAPI?.stop();
		}
	}, [isWindowActive]);

	useEffect(() => {
		const datagame = require("../../assets/text/" + String(lang) + "/game.json");
		const datamenu = require("../../assets/text/" + String(lang) + "/menu.json");
		setDataGame(datagame);
		setDataMenu(datamenu);
	}, [lang]);

	function next(e) {
		if (isAnswerSelected) return;

		const selectedId = e.target.getAttribute("data-id");
		const currentQuestion = dataGame[dataLocalStorage.id];

		document.querySelectorAll(".game-button").forEach((btn) => {
			btn.classList.remove("successfully", "error");
		});

		const newData = { ...dataLocalStorage };

		if (currentQuestion.right.toString() === selectedId) {
			e.target.classList.add("successfully");
			newData.score += ADD_SCORE;
			newData.correctAnswers = (newData.correctAnswers || 0) + 1;
			newData.correctAnswersTest = (newData.correctAnswersTest || 0) + 1;
			if (isSound) playSuccessfullySoundMusic();
		} else {
			e.target.classList.add("error");
			const correctButton = document.querySelector(`[data-id="${currentQuestion.right}"]`);
			if (correctButton) correctButton.classList.add("successfully");
			if (isSound) playErrorSoundMusic();
		}

		setIsAnswerSelected(true);

		setTimeout(() => {
			document.querySelectorAll(".game-button").forEach((btn) => {
				btn.classList.remove("successfully", "error");
			});

			if (dataLocalStorage.id < dataGame.length - 1) {
				if ((dataLocalStorage.id + 1) % NUMBER_QUESTIONS_END === 0 && dataLocalStorage.id !== 0) {
					newData.isMenu = true;
				}
				if (newData.count < NUMBER_QUESTIONS_END) {
					newData.count += 1;
				}
				newData.id += 1;
			} else {
				setIsFinal(true);
				newData.count = NUMBER_QUESTIONS_END;
			}

			setDataLocalStorage(newData);
			setIsAnswerSelected(false);

			if (isSound) {
				stopSuccessfullySoundMusic();
				stopErrorSoundMusic();
			}
		}, DELAY_NEXT_QUESTION_SECONDS * 1000);
	}

	function nextTest() {
		if (typeof YaGames === "undefined" || typeof YaGames.init !== "function") {
			console.error("ysdk.features.GameplayAPI.stop");
		} else {
			console.log("ysdk.features.GameplayAPI.stop");
			ysdk.features.GameplayAPI?.stop();
		}

		// setIsMenu(true);
		setDataLocalStorage({
			...dataLocalStorage,
			count: 1,
			correctAnswersTest: 0,
			isMenu: false,
			id: dataLocalStorage.id + 1,
		});

		if (typeof YaGames === "undefined" || typeof YaGames.init !== "function") {
			console.error("ysdk.adv.showFullscreenAdv");
			console.error("ysdk.features.GameplayAPI.start");
		} else {
			ysdk.adv.showFullscreenAdv({
				callbacks: {
					onOpen: function () {
						console.log("ysdk.adv.showFullscreenAdv.onOpen");
					},
					onClose: function (wasShown) {
						ysdk.features.GameplayAPI?.start();
						console.log("ysdk.adv.showFullscreenAdv.onClose");
						console.log("ysdk.features.GameplayAPI.start");
					},
				},
			});
		}
	}

	function restartGame() {
		setDataLocalStorage({
			...dataLocalStorage,
			count: 1,
			id: 0,
			correctAnswers: 0,
			correctAnswersTest: 0,
		});
		setIsFinal(false);
	}

	function feedback() {
		if (typeof YaGames === "undefined" || typeof YaGames.init !== "function") {
			console.error("ysdk.feedback.canReview");
			return;
		}
		ysdk.feedback.requestReview().then(({ feedbackSent }) => {
			console.log("ysdk.feedback.requestReview");
		});
	}

	if (!dataGame) return <div>...</div>;

	if (dataLocalStorage.isMenu === true) {
		return (
			<div className="game-container">
				<div className="game-text">
					<div>{dataMenu.text1}</div>
					<div>
						{dataLocalStorage.correctAnswersTest || 0} {dataMenu.text2} {NUMBER_QUESTIONS_END}
					</div>
					<div>
						{dataMenu.text3} {dataLocalStorage.correctAnswers || 0} {dataMenu.text4}
					</div>
				</div>
				<div className="game-answers">
					<button className="game-button" onClick={nextTest}>
						{dataMenu.text5}
					</button>
				</div>
			</div>
		);
	}

	if (isFinal) {
		return (
			<div className="game-container">
				<div className="game-text">
					<div>{dataMenu.text1}</div>
					<div>
						{dataMenu.text3} {dataLocalStorage.correctAnswers || 0} {dataMenu.text4}
					</div>
					<div>{dataMenu.text6}</div>
				</div>
				<div className="game-answers">
					{isFeedback && (
						<button className="game-button" onClick={feedback}>
							{dataMenu.text8}
						</button>
					)}
					<button className="game-button" onClick={restartGame}>
						{dataMenu.text7}
					</button>
				</div>
			</div>
		);
	}

	const currentQuestion = dataGame[dataLocalStorage.id];

	return (
		<div className="game-container">
			<div className="game-question">{currentQuestion.title}</div>
			<div className="game-answers">
				{currentQuestion.variants.map((variant, index) => {
					if (index % 2 === 0) {
						return (
							<div key={`wrapper-${index}`} className="button-row">
								<button
									key={index}
									className="game-button"
									onClick={next}
									data-id={index}
									disabled={isAnswerSelected}
								>
									{variant}
								</button>
								{index + 1 < currentQuestion.variants.length && (
									<button
										key={index + 1}
										className="game-button"
										onClick={next}
										data-id={index + 1}
										disabled={isAnswerSelected}
									>
										{currentQuestion.variants[index + 1]}
									</button>
								)}
							</div>
						);
					}
					return null;
				})}
			</div>
		</div>
	);
}
